<template>
    <a
        :href="`/profiles/${user.username}`"
        class="block rounded-lg bg-white hover:bg-gray-100 px-6 pt-4 pb-6 shadow-lg hover:shadow-xl border-transparent border-t-8 hover:border-teal-500 transition duration-200"
    >
        <div class="flex flex-col w-full sm:flex-row items-start">
            <div class="h-16 w-16 mb-3 sm:mb-0 sm:mr-4 flex-none">
                <user-avatar :username="user.name" :avatar-url="user.avatar_url" />
            </div>
            <div class="flex-grow w-full sm:w-auto">
                <div class="flex justify-between mb-5 items-start">
                    <div class="flex flex-col">
                        <h3 class="leading-none text-lg sm:text-2xl font-bold text-gray-900">{{ user.name }}</h3>
                        <span class="leading-relaxed text-teal-500 text-base sm:text-xl">{{ user.profile.title }}</span>
                        <user-rating v-if="user.average_rate" class="mt-1" :rating="user.average_rate" :read-only="true" />
                    </div>
                    <span class="text-sm sm:text-xl text-gray-500 whitespace-nowrap">
                        <span class="font-bold text-gray-900">${{ user.profile.hourly_rate }}</span> / hr
                    </span>
                </div>
                <div class="flex flex-col mr-2">
                    <span class="flex items-center mb-1">
                        <svg-icon icon="work" class="icon-gray w-5 mr-1"></svg-icon>
                        <span class="text-gray-500">
                            <span class="font-bold text-gray-800">{{ user.profile.years_of_experience }}</span>
                            years of experience
                        </span>
                    </span>
                    <span class="flex items-center">
                        <svg-icon icon="location-pin" class="icon-gray w-5 mr-1"></svg-icon>
                        <span class="text-gray-500">{{ user.profile.location }}</span>
                    </span>
                </div>
                <tags-list :tags="toBeShownTags" :plus-more="numOfNotShownTags"></tags-list>
            </div>
        </div>
    </a>
</template>

<script>
export default {
    props: {
        user: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            toBeShownTags: [],
            numOfNotShownTags: 0
        };
    },

    mounted() {
        this.calculateToBeShownTags();
    },

    methods: {
        calculateToBeShownTags() {
            let allTagsTotalStringLength = 0;
            let allTags = this.user.profile.tags_translated;

            this.toBeShownTags = allTags
                .filter(tag => {
                    if (tag.length + allTagsTotalStringLength >= 50) {
                        return false;
                    }

                    allTagsTotalStringLength += tag.length;
                    return true;
                })
                .slice(0, 6);

            this.numOfNotShownTags = allTags.length - this.toBeShownTags.length;
        }
    }
};
</script>
